import { Slide } from '@material-ui/core';
import { UserProfileWizard } from './UserProfileWizard';

/**
 * UserProfileWizardAnimated component renders the user profile wizard with an animated sliding effect.
 */
function UserProfileWizardAnimated({
  openUserProfileWizard,
  setOpenUserProfileWizard,
  setOpenSnoozeSnackBar,
  setOpenCompleteSnackBar
}): JSX.Element {
  return (
    <Slide
      direction='left'
      in={openUserProfileWizard}
      timeout={750}
      mountOnEnter
      unmountOnExit
    >
      <UserProfileWizard
        setOpenWizard={setOpenUserProfileWizard}
        setOpenSnoozeSnackBar={setOpenSnoozeSnackBar}
        setOpenCompleteSnackBar={setOpenCompleteSnackBar}
      />
    </Slide>
  );
}

export default UserProfileWizardAnimated;
